"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActiveMenu = exports.activeMenuContext = exports.ActiveMenuProvider = void 0;
var _toggleMenuFlyout = require("@ori-events/toggle-menu-flyout");
var _react = require("react");
var _searchInputContext = require("./searchInputContext");
var _jsxRuntime = require("react/jsx-runtime");
const activeMenuContext = exports.activeMenuContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = activeMenuContext;
const ActiveMenuProvider = ({
  children
}) => {
  const [activeMenu, setActiveMenu] = (0, _react.useState)('');
  const {
    blur,
    clearResults,
    hide,
    setValue,
    show
  } = (0, _searchInputContext.useSearchInput)();
  const toggleActiveMenu = (0, _react.useCallback)(menu => {
    if (menu === _toggleMenuFlyout.MenuTypes.SearchInput || menu === _toggleMenuFlyout.MenuTypes.SearchResults) {
      show();
      setActiveMenu(menu);
    } else if (activeMenu === menu) {
      hide();
      setActiveMenu('');
    } else {
      hide();
      setActiveMenu(menu);
    }
  }, [activeMenu, hide, show]);
  const hideSearchResultsTab = (0, _react.useCallback)(() => {
    blur();
    clearResults();
    hide();
    setActiveMenu('');
    setValue('');
  }, [blur, clearResults, hide, setValue]);
  const value = (0, _react.useMemo)(() => ({
    activeMenu,
    hideSearchResultsTab,
    toggleActiveMenu
  }), [activeMenu, hideSearchResultsTab, toggleActiveMenu]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.ActiveMenuProvider = ActiveMenuProvider;
const useActiveMenu = () => {
  const context = (0, _react.useContext)(activeMenuContext);
  if (context) {
    return context;
  }
  throw new Error('useActiveMenuContext must be used within a ActiveMenuProvider.');
};
exports.useActiveMenu = useActiveMenu;